import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { MonthlyContractState } from './states'

const MonthlyContract: Module<MonthlyContractState, State> = {
  state: new MonthlyContractState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default MonthlyContract
